import { render } from "./IconLibraryManager.vue?vue&type=template&id=1a887218"
import script from "./IconLibraryManager.vue?vue&type=script&lang=js"
export * from "./IconLibraryManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__